// import { getCart } from '../reducer/facebook-chat-reducer';
import Cookies from "js-cookie";
import { callApiServiceCommon } from "./service-common";
import { getParamsUrlString } from "../helpers";

const shop = getParamsUrlString(
  Cookies.get("autoketing_product_review_session"),
  "shop",
);

function getVal(str) {
  const v = window.location.search.match(new RegExp(`(?:[?&]${str}=)([^&]+)`));
  return v ? v[1] : undefined;
}

const shopUrl = getVal("shop") || shop;

const dashboardApi = process.env.REACT_APP_DASHBOARD_API;
const commonServiceApi = process.env.REACT_APP_API_COMMON_SERVICE;

const blogApi = "https://blog.autoketing.com/autoketingblog-posts";

// PRICING
export function* changeStatusService(status) {
  const payload = {
    method: "POST",
    url: `${dashboardApi}/rev/on-off-app`,
    params: {
      shop_domain: shopUrl,
      status_app: status,
    },
  };
  return yield callApiServiceCommon(payload);
}

export function* getCountReviews() {
  const payload = {
    method: "GET",
    url: `${dashboardApi}/rev/get-list-review-dashboard`,
    params: {
      shop_domain: shopUrl,
    },
  };
  return yield callApiServiceCommon(payload);
}

export function* getListProductReviews(
  status_rev,
  review_rating,
  review_title_like,
  page,
  filter_hidden,
  filter_media,
) {
  const payload = {
    method: "GET",
    url: `${dashboardApi}/rev/get-list-review-dashboard`,
    params: {
      shop_domain: shopUrl,
      status_rev,
      review_rating,
      review_title_like,
      page,
      filter_hidden,
      filter_media,
    },
  };
  return yield callApiServiceCommon(payload);
}

export function* getDetailProductReviews(id) {
  const payload = {
    method: "GET",
    url: `${dashboardApi}/rev/get-list-review-dashboard`,
    params: {
      shop_domain: shopUrl,
      id,
    },
  };
  return yield callApiServiceCommon(payload);
}

export function* changeStatusReview(product_id, email, status_review) {
  const payload = {
    method: "POST",
    url: `${dashboardApi}/rev/publish-review`,
    params: {
      shop_domain: shopUrl,
      email,
      status_review,
      product_id,
    },
  };
  return yield callApiServiceCommon(payload);
}

export function* sendProductReviewComment(
  product_id,
  email,
  comment_author,
  comment_email,
  comment_message,
) {
  const payload = {
    method: "POST",
    url: `${dashboardApi}/rev/send-review-comment`,
    params: {
      shop_domain: shopUrl,
      email,
      comment_author,
      product_id,
      comment_email,
      comment_message,
      comment_id: 0,
      comment_from_admin: true,
    },
  };
  return yield callApiServiceCommon(payload);
}

export function* editReviewComment(
  product_id,
  email,
  comment_author,
  comment_email,
  comment_message,
  comment_id,
) {
  const payload = {
    method: "POST",
    url: `${dashboardApi}/rev/send-review-comment`,
    params: {
      shop_domain: shopUrl,
      email,
      comment_author,
      product_id,
      comment_email,
      comment_message,
      comment_id,
      comment_from_admin: true,
    },
  };
  return yield callApiServiceCommon(payload);
}

export function* deleteReviewComment(product_id, email, comment_id) {
  const payload = {
    method: "POST",
    url: `${dashboardApi}/rev/delete-review-comment`,
    params: {
      shop_domain: shopUrl,
      email,
      comment_id,
      product_id,
    },
  };
  return yield callApiServiceCommon(payload);
}

export function* deleteReview(product_id, email) {
  const payload = {
    method: "POST",
    url: `${dashboardApi}/rev/delete-review`,
    params: {
      shop_domain: shopUrl,
      email,
      product_id,
    },
  };
  return yield callApiServiceCommon(payload);
}

export function* deleteMultipReview(id) {
  const payload = {
    method: "POST",
    url: `${dashboardApi}/rev/delete-review`,
    params: {
      shop_domain: shopUrl,
      list_rev_id: JSON.stringify(id),
    },
  };
  return yield callApiServiceCommon(payload);
}

export function* getSettings() {
  const payload = {
    method: "GET",
    url: `${dashboardApi}/rev/get-settings`,
    params: {
      shop_domain: shopUrl,
    },
  };
  return yield callApiServiceCommon(payload);
}

export function* getShopInfoService(shop) {
  const payload = {
    method: "GET",
    url: `${commonServiceApi}/ak/get-shop-info`,
    params: {
      shop_domain: shop,
      app_code: "rev",
    },
  };
  return yield callApiServiceCommon(payload);
}

export function* updateSettings(param) {
  const payload = {
    method: "POST",
    url: `${dashboardApi}/rev/save-settings`,
    params: {
      form_title: param.form_title,
      review_label: JSON.stringify(param.review_label),
      email: param.email,
      author: param.author,
      p_like_btn_text: param.p_like_btn_text,
      p_unlike_btn_text: param.p_unlike_btn_text,
      review_note_value: param.review_note_value,
      auto_publish_by_rating: param.auto_publish_by_rating,
      show_like_sdk: param.show_like_sdk,
      show_un_like_sdk: param.show_like_sdk,
      primary_color: param.primary_color,
      rating_color: param.rating_color,
      rating_icon: param.rating_icon,
      review_layout: param.review_layout,
      max_rev_in_page: param.max_rev_in_page,
      type_form_rev_sdk: param.type_form_rev_sdk,
      background_color: param.background_color,
      title_color: param.title_color,
      text_color: param.text_color,
      title_section: param.title_section,
      title_app: param.title_app,
      auto_filter_location: param.auto_filter_location,
      secondary_color: param.secondary_color,
      background_color_box: param.background_color_box,
      icon_reaction: param.icon_reaction,
      reaction_color: param.reaction_color,
      verified_badge_status: param.verified_badge_status,
      verified_badge_color: param.verified_badge_color,
      country_flag_status: param.country_flag_status,
      country_flag_style: param.country_flag_style,
      write_review_button_style: param.write_review_button_style,
      write_review_button_color: param.write_review_button_color,
      write_review_button_text: param.write_review_button_text,
      description_review: param.description_review,
      status_upload_image: param.status_upload_image,
      description_reviews: param.description_reviews,
      hidden_filter: param.hidden_filter,
      rating_on_homepage: param.rating_on_homepage,
      rating_on_collection: param.rating_on_collection,
      rating_on_product: param.rating_on_product,
      reaction_on_off: param.reaction_on_off,
      form_your_rating: param.form_your_rating,
      form_box_name: param.form_box_name,
      form_box_email: param.form_box_email,
      form_box_title: param.form_box_title,
      form_box_feedback: param.form_box_feedback,
      form_choose_photo: param.form_choose_photo,
      title_thank_you_text: param.title_thank_you_text,
      content_thank_you_text: param.content_thank_you_text,
      filter_text: param.filter_text,
      filter_five_stars_text: param.filter_five_stars_text,
      filter_four_stars_text: param.filter_four_stars_text,
      filter_three_stars_text: param.filter_three_stars_text,
      filter_two_stars_text: param.filter_two_stars_text,
      filter_one_star_text: param.filter_one_star_text,
      sort_by_text: param.sort_by_text,
      sort_by_highest_rating_text: param.sort_by_highest_rating_text,
      sort_by_lowest_rating_text: param.sort_by_lowest_rating_text,
      sort_by_newest_text: param.sort_by_newest_text,
      sort_by_oldest_text: param.sort_by_oldest_text,
      date_review_status: param.date_review_status,
      date_review_color: param.date_review_color,
      icon_rating_follow_theme: param.icon_rating_follow_theme,
      confirmed_text: param.confirmed_text,
      read_more_text: param.read_more_text,
      form_button_submit: param.form_button_submit,
      form_button_cancel: param.form_button_cancel,
      show_all_review_on_product: param.show_all_review_on_product,
      hidden_rating_null_collections: param.hidden_rating_null_collections,
    },
  };
  return yield callApiServiceCommon(payload);
}

export function* exportExcel() {
  const payload = {
    method: "POST",
    url: `${dashboardApi}/rev/export-data-reviews`,
    params: {
      shop_domain: shopUrl,
    },
  };
  return yield callApiServiceCommon(payload);
}

export function* importExcel(csv_file, list_handle) {
  const payload = {
    method: "POST",
    url: `${dashboardApi}/rev/import-data-reviews`,
    params: {
      shop_domain: shopUrl,
      csv_file,
      list_handle: JSON.stringify(list_handle),
    },
  };
  return yield callApiServiceCommon(payload);
}

export function* changeAdminReadAt(product_id, email) {
  const payload = {
    method: "POST",
    url: `${dashboardApi}/rev/admin-read-review`,
    params: {
      shop_domain: shopUrl,
      product_id,
      email,
    },
  };
  return yield callApiServiceCommon(payload);
}

export function* getFormEmailReview() {
  const payload = {
    method: "GET",
    url: `${dashboardApi}/rev/get-form-email-review`,
    params: {
      shop_domain: shopUrl,
    },
  };
  return yield callApiServiceCommon(payload);
}

export function* getFormEmailReviewComment() {
  const payload = {
    method: "GET",
    url: `${dashboardApi}/rev/get-form-email-review-comment`,
    params: {
      shop_domain: shopUrl,
    },
  };
  return yield callApiServiceCommon(payload);
}

export function* getFormEmailReviewOrderService() {
  const payload = {
    method: "GET",
    url: `${dashboardApi}/rev/get-form-email-orders-fulfilled`,
    params: {
      shop_domain: shopUrl,
    },
  };
  return yield callApiServiceCommon(payload);
}

export function* callSaveCampaign(param) {
  let url;
  switch (param.form_type) {
    case "review":
      url = `${dashboardApi}/rev/save-form-email-review`;
      break;
    case "review-comment":
      url = `${dashboardApi}/rev/save-form-email-review-comment`;
      break;
    default:
      url = `${dashboardApi}/rev/save-form-email-orders-fulfilled`;
      break;
  }
  const payload = {
    method: "POST",
    url,
    params: {
      shop_domain: shopUrl,
      sender_name: param.senderName,
      sender_email: param.senderEmail,
      reply_to: param.replyTo,
      subject_email: param.subject,
      content_email: param.saveCampaignData.html,
      design_email: JSON.stringify(param.saveCampaignData.design),
      time_to_send: param.timeToSend,
      time_to_send_type: param.timeToSendType,
    },
  };

  return yield callApiServiceCommon(payload);
}

export function* changeActiveFormReview(on_off_sendmail) {
  const payload = {
    method: "POST",
    url: `${dashboardApi}/rev/on-off-email-review`,
    params: {
      shop_domain: shopUrl,
      on_off_sendmail,
    },
  };
  return yield callApiServiceCommon(payload);
}

export function* changeActiveFormReviewComment(on_off_sendmail) {
  const payload = {
    method: "POST",
    url: `${dashboardApi}/rev/on-off-email-review-comment`,
    params: {
      shop_domain: shopUrl,
      on_off_sendmail,
    },
  };
  return yield callApiServiceCommon(payload);
}

export function* changeActiveFormReviewOrder(on_off_sendmail) {
  const payload = {
    method: "POST",
    url: `${dashboardApi}/rev/on-off-email-orders-fulfilled`,
    params: {
      shop_domain: shopUrl,
      on_off_sendmail,
    },
  };
  return yield callApiServiceCommon(payload);
}

export function* getStatusFormEmailReview() {
  const payload = {
    method: "GET",
    url: `${dashboardApi}/rev/get-form-email-review`,
    params: {
      shop_domain: shopUrl,
    },
  };
  return yield callApiServiceCommon(payload);
}

export function* getStatusFormEmailReviewComment() {
  const payload = {
    method: "GET",
    url: `${dashboardApi}/rev/get-form-email-review-comment`,
    params: {
      shop_domain: shopUrl,
    },
  };
  return yield callApiServiceCommon(payload);
}

export function* sendTestEmail(param) {
  const payload = {
    method: "POST",
    url: `${dashboardApi}/rev/sent-test-email`,
    params: {
      shop_domain: shopUrl,
      sender_name: param.senderName,
      sender_email: param.senderEmail,
      reply_to: param.replyTo,
      subject_email: param.subject,
      content_email: param.saveCampaignData.html,
      to_email: param.toEmail,
      to_author: param.toAuthor,
      time_to_send: param.timeToSend,
      time_to_send_type: param.timeToSendType,
    },
  };
  return yield callApiServiceCommon(payload);
}

export function* getStatisticBar(param) {
  const payload = {
    method: "GET",
    url: `${dashboardApi}/rev/get-statistic-bar-chart`,
    params: {
      start_date: param.startDate,
      end_date: param.endDate,
    },
  };
  return yield callApiServiceCommon(payload);
}

export function* getStatisticRating(param) {
  const payload = {
    method: "GET",
    url: `${dashboardApi}/rev/get-statistic-rating`,
    params: {
      start_month: param.startMonth,
      end_month: param.endMonth,
    },
  };
  return yield callApiServiceCommon(payload);
}

export function* getListLogEmail() {
  const payload = {
    method: "GET",
    url: `${dashboardApi}/rev/get-list-logs-email`,
    params: {
      limit: 7,
      page: 1,
    },
  };
  return yield callApiServiceCommon(payload);
}

export function* getStatisticCountTotal() {
  const payload = {
    method: "GET",
    url: `${dashboardApi}/rev/get-statistic-count-total`,
    params: {},
  };
  return yield callApiServiceCommon(payload);
}

export function* getStatisticEmail() {
  const payload = {
    method: "GET",
    url: `${dashboardApi}/rev/get-statistic-email`,
    params: {},
  };
  return yield callApiServiceCommon(payload);
}

export function* getListProduct(param) {
  const payload = {
    method: "GET",
    url: `${dashboardApi}/rev/graphql-query`,
    params: {
      graphql_query: param,
    },
  };
  return yield callApiServiceCommon(payload);
}

export function* getListProductSearch(param) {
  const payload = {
    method: "GET",
    url: `${dashboardApi}/rev/graphql-query`,
    params: {
      graphql_query: param,
    },
  };
  return yield callApiServiceCommon(payload);
}

export function* getRateProduct(list_product_id) {
  const payload = {
    method: "GET",
    url: `${dashboardApi}/rev/get-rating-average-products`,
    params: {
      list_product_id: JSON.stringify(list_product_id),
    },
  };
  return yield callApiServiceCommon(payload);
}

export function* getContentLogEmail(id) {
  const payload = {
    method: "GET",
    url: `${dashboardApi}/rev/get-content-logs-email`,
    params: {
      id,
    },
  };
  return yield callApiServiceCommon(payload);
}

export function* getListEmailVerify() {
  const payload = {
    method: "GET",
    url: `${dashboardApi}/rev/get-list-email-verified`,
    params: {},
  };
  return yield callApiServiceCommon(payload);
}

export function* getListBlog(number) {
  const payload = {
    method: "GET",
    url: `${blogApi}`,
    params: {
      "post-per-page": number,
    },
  };
  return yield callApiServiceCommon(payload);
}

export function* getCountTotalProduct() {
  const payload = {
    method: "GET",
    url: `${dashboardApi}/rev/shop-count-product`,
    params: {},
  };
  return yield callApiServiceCommon(payload);
}

export function* getRandomProduct() {
  const payload = {
    method: "GET",
    url: `${dashboardApi}/rev/get-random-product`,
    params: {},
  };
  return yield callApiServiceCommon(payload);
}

export function* hiddenReview(param) {
  const payload = {
    method: "POST",
    url: `${dashboardApi}/rev/hidden-review`,
    params: {
      hidden: param.hidden,
      product_id: param.product_id,
      email: param.email,
    },
  };
  return yield callApiServiceCommon(payload);
}

export function* changeStatusPopupReview(param) {
  const payload = {
    method: "POST",
    url: `${dashboardApi}/rev/on-off-popup`,
    params: {
      popup_status: param,
    },
  };
  return yield callApiServiceCommon(payload);
}

export function* getSettingsPopupReview() {
  const payload = {
    method: "GET",
    url: `${dashboardApi}/rev/get-popup-settings`,
    params: {},
  };
  return yield callApiServiceCommon(payload);
}

export function* changeStatusGoogleSnippet(param) {
  const payload = {
    method: "POST",
    url: `${dashboardApi}/rev/on-off-google-snippet`,
    params: {
      on_off_google_snippet: param,
    },
  };
  return yield callApiServiceCommon(payload);
}

export function* getSettingsGoogleSnippet() {
  const payload = {
    method: "GET",
    url: `${dashboardApi}/rev/get-google-snippet-settings`,
    params: {},
  };
  return yield callApiServiceCommon(payload);
}

export function* changeStatusCustomerSay(param) {
  const payload = {
    method: "POST",
    url: `${dashboardApi}/rev/on-off-customer-say`,
    params: {
      customer_say_status: param,
    },
  };
  return yield callApiServiceCommon(payload);
}

export function* getSettingsCustomerSay() {
  const payload = {
    method: "GET",
    url: `${dashboardApi}/rev/get-customer-say-settings`,
    params: {},
  };
  return yield callApiServiceCommon(payload);
}

export function* saveCustomerSaySettings(params) {
  const payload = {
    method: "POST",
    url: `${dashboardApi}/rev/save-customer-say-settings`,
    params: {
      list_review_id: JSON.stringify(params.list_review_id || []),
      title_section: params.title_section,
      title_section_color: params.title_section_color,
      background_color_section: params.background_color_section,
      background_color_card: params.background_color_card,
      color_primary: params.color_primary,
      color_secondary: params.color_secondary,
      author_status: params.author_status,
      author_color: params.author_color,
      email_status: params.email_status,
      email_color: params.email_color,
      style_section: params.style_section,
    },
  };
  return yield callApiServiceCommon(payload);
}

export function* getListDetailByHandles(list_handle) {
  const payload = {
    method: "GET",
    url: `${dashboardApi}/rev/get-list-detail-by-handles`,
    params: {
      list_handle: JSON.stringify(list_handle),
    },
  };
  return yield callApiServiceCommon(payload);
}

export function* getListCustomerSayById(listId) {
  let list_id;
  if (listId.length > 0) {
    list_id = listId.join(",");
  }
  const payload = {
    method: "GET",
    url: `${dashboardApi}/rev/get-list-customer-say-by-id`,
    params: {
      list_id,
    },
  };
  return yield callApiServiceCommon(payload);
}

export function* saveSettingsPopupReview(param) {
  const payload = {
    method: "POST",
    url: `${dashboardApi}/rev/save-popup-settings`,
    params: {
      popup_type_setup: param.popup_type_setup,
      popup_custom_list: JSON.stringify(param.popup_custom_list),
      template_popup_review_checkout: param.template_popup_review_checkout,
      image_product_status_checkout: param.image_product_status_checkout,
      color_border_image_checkout: param.color_border_image_checkout,
      status_border_checkout: param.status_border_checkout,
      color_makeup_image_checkout: param.color_makeup_image_checkout,
      status_makeup_image_checkout: param.status_makeup_image_checkout,
      makeup_icon_image_checkout: param.makeup_icon_image_checkout,
      status_makeup_icon_image_checkout:
        param.status_makeup_icon_image_checkout,
      icon_rating_checkout: param.icon_rating_checkout,
      color_icon_rating_checkout: param.color_icon_rating_checkout,
      title_popup_review_checkout: param.title_popup_review_checkout,
      color_title_popup_review_checkout:
        param.color_title_popup_review_checkout,
      content_popup_review_checkout: param.content_popup_review_checkout,
      color_content_popup_review_checkout:
        param.color_content_popup_review_checkout,
      text_rating_popup_review_checkout:
        param.text_rating_popup_review_checkout,
      color_text_rating_popup_review_checkout:
        param.color_text_rating_popup_review_checkout,
      background_color_popup_review_checkout:
        param.background_color_popup_review_checkout,
      show_homepage_checkout: param.show_homepage_checkout,
      show_collections_page_checkout: param.show_collections_page_checkout,
      show_product_detail_checkout: param.show_product_detail_checkout,
      position_popup_checkout: param.position_popup_checkout,
      review_label_checkout: JSON.stringify(param.review_label_checkout),
      style_theme_checkout: param.style_theme_checkout,
      background_color_secondary_checkout:
        param.background_color_secondary_checkout,

      // manually
      template_popup_review_manually: param.template_popup_review_manually,
      image_product_status_manually: param.image_product_status_manually,
      color_border_image_manually: param.color_border_image_manually,
      status_border_manually: param.status_border_manually,
      color_makeup_image_manually: param.color_makeup_image_manually,
      status_makeup_image_manually: param.status_makeup_image_manually,
      makeup_icon_image_manually: param.makeup_icon_image_manually,
      status_makeup_icon_image_manually:
        param.status_makeup_icon_image_manually,
      icon_rating_manually: param.icon_rating_manually,
      color_icon_rating_manually: param.color_icon_rating_manually,
      title_popup_review_manually: param.title_popup_review_manually,
      color_title_popup_review_manually:
        param.color_title_popup_review_manually,
      content_popup_review_manually: param.content_popup_review_manually,
      color_content_popup_review_manually:
        param.color_content_popup_review_manually,
      text_rating_popup_review_manually:
        param.text_rating_popup_review_manually,
      color_text_rating_popup_review_manually:
        param.color_text_rating_popup_review_manually,
      background_color_popup_review_manually:
        param.background_color_popup_review_manually,
      show_homepage_manually: param.show_homepage_manually,
      show_collections_page_manually: param.show_collections_page_manually,
      show_product_detail_manually: param.show_product_detail_manually,
      position_popup_manually: param.position_popup_manually,
      review_label_manually: JSON.stringify(param.review_label_manually),
      style_theme_manually: param.style_theme_manually,
      background_color_secondary_manually:
        param.background_color_secondary_manually,

      // order
      template_popup_review_order: param.template_popup_review_order,
      image_product_status_order: param.image_product_status_order,
      color_border_image_order: param.color_border_image_order,
      status_border_order: param.status_border_order,
      color_makeup_image_order: param.color_makeup_image_order,
      status_makeup_image_order: param.status_makeup_image_order,
      makeup_icon_image_order: param.makeup_icon_image_order,
      status_makeup_icon_image_order: param.status_makeup_icon_image_order,
      icon_rating_order: param.icon_rating_order,
      color_icon_rating_order: param.color_icon_rating_order,
      title_popup_review_order: param.title_popup_review_order,
      color_title_popup_review_order: param.color_title_popup_review_order,
      content_popup_review_order: param.content_popup_review_order,
      color_content_popup_review_order: param.color_content_popup_review_order,
      text_rating_popup_review_order: param.text_rating_popup_review_order,
      color_text_rating_popup_review_order:
        param.color_text_rating_popup_review_order,
      background_color_popup_review_order:
        param.background_color_popup_review_order,
      show_homepage_order: param.show_homepage_order,
      show_collections_page_order: param.show_collections_page_order,
      show_product_detail_order: param.show_product_detail_order,
      position_popup_order: param.position_popup_order,
      review_label_order: JSON.stringify(param.review_label_order),
      style_theme_order: param.style_theme_order,
      background_color_secondary_order: param.background_color_secondary_order,
    },
  };
  return yield callApiServiceCommon(payload);
}
